module.exports = __webpack_public_path__ + "media/images/voice02-f58cca3a5143b5a6b3b5285113dbaae3.jpg";